## サービス

- [www.yude.jp.eu.org](https://www.yude.jp.eu.org)

## リンク

- [GitHub Organization](https://github.com/yudejp)
- [Discord サーバー](https://discord.gg/X6srY7X)
